export const landing = {
  hero: {
    titleLine1: 'Play.',
    titleLine2: 'Win.',
    titleLine3: 'Earn.',
    subtitleLine1: 'Get a $5 bonus on your first deposit.',
    subtitleLine2: 'You can use this bonus as an entry fee for the tournament.',
    signup: 'Sign up right now!',
  },
  platform: {
    title:
      'A platform<br />with trusted games\u00A0— from <quick>quick</quick> battles to\u00A0<strategy>strategy</strategy> duels',
  },
  reasons: {
    title: '4 reasons<br />to start <playing>playing</playing> <br />right now',
  },
  features: {
    fairCompetitions: {
      title: 'Fair Competitions',
      description:
        'Players are matched by skill —<br />only the strongest wins!',
    },
    quickMatchStart: {
      title: 'Quick match start',
      description: 'Find an opponent<br />in 60 seconds and jump in',
    },
    instantPayouts: {
      title: 'Instant payouts',
      description: 'Winnings are credited<br />right after the game ends',
    },
    antiCheatSystem: {
      title: 'Anti-cheat system',
      description:
        "Our algorithms ensure fair play —<br />cheaters don't stand a chance",
    },
  },
  cta: {
    titleMain: 'Sign up And play',
    titleAccent: 'in 2 minutes!',
    bullet1: 'Only your skill defines the result!',
    bullet2: 'The best player wins the competition.',
    bullet3: 'You can withdraw your winnings at any time.',
    support: "Still have any questions?<br />we're here to help!",
    chatButton: 'Contact us via live chat',
    robotAlt: 'Robot',
  },
};
